<div class="employee-details">
  <span *ngIf="firstName || lastName"
    >{{ firstName }}
    {{ lastName }}
    <span>&nbsp;&mdash;&nbsp;</span>
  </span>
  <span>Employee ID: {{ employeeId }}</span>
</div>
